export const restrictInputTo150Chars = (value) => {
  if (!value) return '';
  
  let processedValue = value;
  processedValue = processedValue.replace(/\n/g, ' ');
  processedValue = processedValue.replace(/\s+/g, ' ');
  return processedValue.substring(0, 150);
};

export const handleRestrictedInputChange = (event, setFormData, fieldName) => {
  const { value } = event.target;
  const restrictedValue = restrictInputTo150Chars(value);
  
  setFormData((prev) => ({
    ...prev,
    [fieldName]: restrictedValue
  }));
};